import Cookies from "universal-cookie";

export function setCookie(
  key: string,
  data: string | object,
  expiredDay: number = -1
) {
  const options: { path: string; expires?: Date } = {
    path: "/",
  };

  const coookie = new Cookies();

  if (expiredDay > -1) {
    const sevenDaysFromNow = new Date(
      Date.now() + expiredDay * 24 * 60 * 60 * 1000
    );
    options.expires = sevenDaysFromNow;
  }
  coookie.set(key, data, options);
}

export function setCookieWithDomain(
  key: string,
  data: string | object,
  domain: string,
  expiredDay: number = -1
) {
  const options: { path: string; domain: string; expires?: Date } = {
    path: "/",
    domain: domain,
  };

  const coookie = new Cookies();
  if (expiredDay > -1) {
    const sevenDaysFromNow = new Date(
      Date.now() + expiredDay * 24 * 60 * 60 * 1000
    );
    options.expires = sevenDaysFromNow;
  }
  coookie.set(key, data, options);
}

export function removeCookie(key: string) {
  const coookie = new Cookies();
  coookie.remove(key, { path: "/" });
}

export function getCookie(key: string) {
  const cookie = new Cookies();
  return cookie.get(key);
}
